import { useState } from "react";
const useSwipe = (onSwipeLeft, onSwipeRight, threshold = 50) => {
  const [touchStartX, setTouchStartX] = useState(0);
  const [touchEndX, setTouchEndX] = useState(0);
  const onTouchStart = (event) => {
    event.stopPropagation();
    setTouchStartX(event.touches[0].clientX);
  };
  const onTouchMove = (event) => {
    event.stopPropagation()
    setTouchEndX(event.touches[0].clientX);
  };
  const onTouchEnd = () => {
    if (touchEndX) {
      if (touchStartX - touchEndX > threshold) {
        onSwipeLeft();
      } else if (touchStartX - touchEndX < -threshold) {
        onSwipeRight();
      }
      setTouchEndX(0);
    }
  };
  return {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
  };
};
export default useSwipe;